import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { Dynamic } from '@shared/registry/dynamic';

import { type ChipConfig } from './chip.types';

@Component({
  selector: 'app-chip',
  templateUrl: './chip.html',
  imports: [Dynamic, NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Chip {
  readonly config = input.required<ChipConfig>();

  readonly isOutlined = computed(() => this.config().variant === 'outlined');

  readonly backgroundColor = computed(() => `var(--chip-${this.config().variant}-background)`);

  readonly iconColor = computed(() =>
    this.isOutlined() ? undefined : `var(--chip-${this.config().variant}-icon-color)`,
  );

  readonly iconGradient = computed(() => (this.isOutlined() ? 'primary' : undefined));

  readonly textConfig = computed(() => ({
    text: this.config().text,
    size: 'sm',
    fontWeight: 'bold' as const,
    cssVarPrefix: 'chip',
    ...(this.isOutlined() ? { gradient: 'primary' } : { color: `var(--chip-${this.config().variant}-color)` }),
  }));
}
